// Module
var code = "<div class=\"im-float-view im-draggable-content\"> <div class=\"im-float-view-header im-draggable-bar\"> <p class=\"im-float-view-title\"> <span class=\"im-float-records\"></span> </p> <div class=\"im-float-close\"></div> </div> <div class=\"im-float-view-body\"> </div> </div> ";
// Exports
module.exports = code;